import { IpGeoResponse } from '@/pages/api/proxy';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useLocalStorage } from 'usehooks-ts';
export default function useGetLocation() {
  const [useOnRamper, setUseOnRamper] = useLocalStorage('useOnRamper', false);
  const [geoCountry, setGeoCountry] = useState('');
  const [geoState, setGeoState] = useState('');
  const [onlyAllowStripe, setOnlyAllowStripe] = useState(false);
  const [hasBeenSet, setHasBeenSet] = useLocalStorage('hasBeenSetDeposit', false);
  const {
    data
  } = useQuery({
    queryKey: ['userLocation'],
    queryFn: async (): Promise<IpGeoResponse> => {
      const locationResponse = await fetch('/api/proxy');
      const locationData = await locationResponse.json();
      return locationData;
    },
    staleTime: 1000 * 60 * 10
  });
  useEffect(() => {
    const country = data?.country_name;
    const state = data?.region_code;
    if ((!data || hasBeenSet) && state != 'NY') return;
    setGeoCountry(country);
    setGeoState(state);
    setUseOnRamper(country != 'United States' || state == 'NY');
    setOnlyAllowStripe(state == 'NY');
    setHasBeenSet(true);
  }, [data]);
  return {
    data,
    geoCountry,
    geoState,
    useOnRamper,
    setUseOnRamper
  };
}